import { el } from '../ui/dom';

/** Tiny perf readout, only shown with ?debug. */
export class FpsMeter {
  private readonly node: HTMLElement;
  private frames = 0;
  private steps = 0;
  private dropped = 0;
  private lastReport = 0;

  constructor(root: HTMLElement, enabled: boolean) {
    this.node = el('div', { class: 'panel fps' });
    this.node.style.display = enabled ? '' : 'none';
    root.append(this.node);
  }

  frame(nowMs: number, steps: number, droppedSeconds: number): void {
    this.frames += 1;
    this.steps += steps;
    this.dropped += droppedSeconds;
    if (nowMs - this.lastReport >= 1000) {
      this.node.textContent = `${this.frames} fps · ${this.steps} steps/s${this.dropped > 0 ? ` · dropped ${this.dropped.toFixed(1)}s` : ''}`;
      this.frames = 0;
      this.steps = 0;
      this.dropped = 0;
      this.lastReport = nowMs;
    }
  }
}
